import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

import { UserCompany } from '@/store/api';

import { getCompanyRoleColor } from '@/utils/helpers';

import {
  chipSx,
  menuItemContainerSx,
  menuItemTextSx,
  menuPaperSx,
} from './SuperUserCompanyMenu.styles';

interface SuperUserCompanyMenuProps {
  selectedCompanyId: string | null;
  onCompanyChange: (companyId: string) => void;
  userCompanies: UserCompany[];
}

export default function SuperUserCompanyMenu({
  selectedCompanyId,
  onCompanyChange,
  userCompanies,
}: Readonly<SuperUserCompanyMenuProps>) {
  const selectedCompany =
    userCompanies?.find(c => c.id === selectedCompanyId) ?? null;

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={userCompanies || []}
      value={selectedCompany}
      onChange={(_, company) => company && onCompanyChange(company.id)}
      getOptionLabel={option => option.name}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      slotProps={{
        listbox: { sx: menuPaperSx },
      }}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <MenuItem key={key} {...rest}>
            <Box sx={menuItemContainerSx}>
              <Chip
                label={option.roleName}
                size="small"
                color={getCompanyRoleColor(option.companyRole)}
                variant="outlined"
                sx={chipSx}
              />
              <Box sx={menuItemTextSx}>{option.name}</Box>
            </Box>
          </MenuItem>
        );
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Current Company"
          onKeyDown={e => e.stopPropagation()}
        />
      )}
    />
  );
}
